import { type AnalyticsEvent, trackAnalyticsEvent } from '@autone/analytics';

type AssortmentAnalyticsTableEvent = Extract<
  AnalyticsEvent,
  { category: 'assortment_tables' }
>;

type AssortmentAnalyticsTableNames =
  AssortmentAnalyticsTableEvent['action'] extends `${infer TableName}:${string}`
    ? TableName
    : never;

interface TrackTableAnalyticsEventProps {
  tableName: AssortmentAnalyticsTableNames;
  filterDimensionsApplied?: string[];
  advancedFilterFieldsApplied?: string[];
  sortBy?: `${string}:${'asc' | 'desc'}`;
}

export const trackAssortmentTableEvents = ({
  tableName,
  filterDimensionsApplied,
  advancedFilterFieldsApplied,
  sortBy,
}: TrackTableAnalyticsEventProps) => {
  if (sortBy) {
    trackAnalyticsEvent({
      category: 'assortment_tables',
      action: `${tableName}:column_sort_updated`,
      properties: {
        sort_by: sortBy,
      },
    });
  }
  if (filterDimensionsApplied && filterDimensionsApplied.length > 0) {
    trackAnalyticsEvent({
      category: 'assortment_tables',
      action: `${tableName}:filters_updated`,
      properties: Object.fromEntries(
        filterDimensionsApplied.map((dim) => [dim, true]),
      ),
    });
  }
  if (advancedFilterFieldsApplied && advancedFilterFieldsApplied.length > 0) {
    trackAnalyticsEvent({
      category: 'assortment_tables',
      action: `${tableName}:advanced_filters_updated`,
      properties: Object.fromEntries(
        advancedFilterFieldsApplied.map((field) => [field, true]),
      ),
    });
  }
};
